<template>
	<v-row class="prop-list-row" :class="{ flash }" dense>
		<v-col class="prop-key">{{ name }}</v-col>
		<v-col class="prop-value">{{ timeAgo }}</v-col>
	</v-row>
</template>

<style lang="scss" scoped src="./PropList.scss"></style>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
	props: {
		node: { type: Object, required: true },
		subpath: { type: String, required: true },
	},

	data: () => ({
		flash: false,
	}),

	computed: {
		...mapGetters({ eventData: "controller/eventData" }),

		name() {
			return _.startCase(_.last(this.subpath.split("/")));
		},

		fullPath() {
			return `${this.node.path}/${this.subpath}`;
		},

		timeAgo() {
			return _.get(this.eventData(this.fullPath), "timeAgo");
		},
	},

	watch: {
		timeAgo(val) {
			this.flash = !!val;
		},
	},
};
</script>
